// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'
import * as Popper from "@popperjs/core"
